"use client";
import { Components } from "@mui/material";
import { Theme } from "@mui/material/styles";

type MuiOutlinedInputABStyleOverrides = Components<Theme>["MuiOutlinedInput"];

export const muiOutlinedInputABStyles: MuiOutlinedInputABStyleOverrides = {
  styleOverrides: {
    root: ({ theme }) => ({
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.primary[300],
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.primary[300],
      },
      "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.neutral.light,
        color: theme.palette.neutral.light,
      },
      "&.Mui-error .MuiOutlinedInput-input": {
        color: theme.palette.neutral[900],
      },
      "&.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.error.main,
      },
      "&.Mui-error:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: theme.palette.error.main,
      },
      backgroundColor: theme.palette.common.white,
      borderRadius: 8,
      "&.MuiInputBase-adornedEnd .MuiInputAdornment-positionEnd": {
        position: "absolute",
        right: "1rem",
      },
    }),
    input: ({ theme }) => ({ color: theme.palette.neutral[900] }),
    notchedOutline: ({ theme }) => ({
      borderRadius: 8,
      borderColor: theme.palette.primary.main,
    }),
  },
};
